import {Accordion, Card} from "react-bootstrap";
import pdfIcon from "../../images/pdf-icon.svg";
import React, {useEffect} from "react";

const DocumentList = (props) => {

  return (
    <>
      { props.data && props.data.length > 0 && props.data.map((value, key) => {
        return (
          <Card className="consent-benefit" key={key}>
              <Card.Body>
                <p className="text-blue-light text-center mt-3">
                  { value.title }
                </p>
                <p className="text-center mt-3 mb-0">
                  <label className="normal-text mb-0">
                    <a
                      href={value.link}
                      style={{ textDecoration: "none", color: "#ffffff" }}
                      download={value.file_name} //{true}
                    >
                      <button
                        className="btn btn-primary"
                        style={{
                          borderRadius: 24,
                          backgroundImage: "linear-gradient(to right, #66bff9, #379eec)" ,
                          border: "0"
                        }}
                      >
                        <img src={pdfIcon}/>Download
                      </button>
                    </a>
                  </label>
                </p>
              </Card.Body>
          </Card>
        )
      })}
    </>
  )
}

export default DocumentList